// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.timelesswallet",
    name: "Timeless X",
    homepage: "https://timelesswallet.xyz",
    image_id: "92f1ead4-0bc4-4932-10d3-761c509b4d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/timeless-x/id6470180600",
        android: "https://play.google.com/store/apps/details?id=xyz.timelesswallet.aa",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/ifcpkdgcgcepjdkfcogehpnhpipejgho",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "timeless-x://connect",
        universal: "https://timelesswallet.xyz/x",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map